//@ts-check
import React from "react"
const CONSTS = require("shared/consts")
import CompileContractStep from "./compile-short"
import EncodeTransactionStep from "./compile-short"
import EtherFundStep from "./fund-ether-step"
import CheckBalanceStep from "./check-balance-step"
import store, { qs } from "../store"
import ExpectedResult from "./expected-result"
import SkipStep from "./step-skip"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import ExpectedOutput from "./expected-output"
import ExpectedEvent from "./expected-event"
import ChoosetTimeStamp from "./choose-timestamp"
import { useStepIndex } from "./step-index-context"
import ChooseBlockNumber from "./choose-blocknumber"

/**
 * @param object {Object}
 * @param [object.abi] {import("../../../backend/interfaces").ABIField[]}
 * @param object.collapse, {any}
 * @param object.setCollapse, {any}
 */

function StepEdit({ collapse }) {
  const { isLoggedIn } = useIsLoggedIn();
  // console.log('step edit rerender')
  var stepIndex = useStepIndex()

  if (store.steps.length) {
    return (
      <div
        css={`
            /* padding: 0 15px; */
            margin:10px;
            /* display: ${collapse ? "none" : "flex"}; */
          `}
      >
        <div>
          {store.steps[stepIndex].type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT && (
            <div>
              <CompileContractStep />
            </div>
          )}
          {store.steps[stepIndex].type == CONSTS.STEP_TYPES.CHECk_BALANCE && (
            <div>
              <CheckBalanceStep />
            </div>
          )}
          {store.steps[stepIndex].type == CONSTS.STEP_TYPES.ETHER_FUND && (
            <div>
              <EtherFundStep />
            </div>
          )}
          {store.steps[stepIndex].type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION &&
            <div>
              <EncodeTransactionStep />
            </div>
          }

          <div css="font-size: 0.77rem;">
            {
              isLoggedIn && store.userIsAllowed(isLoggedIn['email']) &&
              <div>
                <div css="background: white">
                  <SkipStep />
                </div>
              </div>
            }

            {store.steps[stepIndex].type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION && !store.steps[stepIndex]['skip'] && isLoggedIn &&
              <ExpectedResult />
            }
            {
              (store.steps[stepIndex].type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION ||
                store.steps[stepIndex].type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT) &&
              <ChoosetTimeStamp />
            }
              <ChooseBlockNumber />
            {
              (store.steps[stepIndex].type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION
                || store.steps[stepIndex].type == CONSTS.STEP_TYPES.CHECk_BALANCE)
              &&
              <ExpectedOutput />
            }
            {
              (store.steps[stepIndex].type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT
                || store.steps[stepIndex].type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION)
              &&
              <ExpectedEvent />
            }
          </div>
        </div>
        <div></div>
      </div>
    )
  } else {
    return null
  }
}

export default StepEdit
